import _constant from "./constants";
import common from "./common";

export const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    const context = this;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      console.log("called");
      func.apply(context, args);
    }, delay);
  };
};

export const formatDate = (format, date) => {
  let formattedDate = "";
  if (format && date) {
    switch (format) {
      case "DD/MM/YYYY": {
        formattedDate = dateInDDMMYYYY(date, "/");
        break;
      }
      case "DD-MM-YYYY": {
        formattedDate = dateInDDMMYYYY(date, "-");
        break;
      }
    }
  }
  return formattedDate;
};
export const toDate = dateStr => {
  if (dateStr) {
    const parts = dateStr.split(_constant.DATE_ORDINAL);
    return new Date(parts[2], parts[1] - 1, parts[0]);
  }
  return false;
};
let dateInDDMMYYYY = (date, symbol) => {
  symbol = symbol || _constant.DATE_ORDINAL;
  date = new Date(date) || new Date();
  let dd = date.getDate();
  let mm = date.getMonth() + 1; // January is 0!

  const yyyy = date.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${dd}${symbol}${mm}${symbol}${yyyy}`;
};

export const isNumber = e => {
  if (!e) return false;
  if (typeof e !== "object" && /^\d+$/.test(e)) return true;

  let digit = String.fromCharCode(e.which);
  if (e.key !== undefined) {
    digit = e.key;
  }
  // any other character than digit
  if (!/^\d+$/.test(digit)) {
    // allow backspace, tab and right/left arrow
    if (e.which !== 8 && e.which !== 9 && e.which !== 37 && e.which !== 39) {
      return false;
    }
  }
  return true;
};

export const mobileValidation = event => {
  const rgx = _constant.MOBILE_REG_EX;
  if (event) {
    if (event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 9) return true;
    if (event.target) {
      const value = event.target.value.replace(/[^0-9]/g, "");
      const digit = String.fromCharCode(event.which);
      if (event && event.target && !value && digit !== undefined && digit < 6) {
        event.target.value = "";
        return false;
      }

      if (value.length < 10 && (rgx.test(event.key) || (value.length >= 1 && rgx.test(value)))) {
        return true;
      }
      if (event.keyCode === 8) {
        return true;
      }
      return false;
    }
  }
};
export const showCountryCode = event => {
  if (event.target && event.target.value.length > 0) {
    return true;
  }
  return false;
};

export const mobileNumberFormatSpace = val => {
  val = val ? val.replace(/[^0-9]/g, "") : "";
  if (val.length >= 6) {
    return `${val.substring(0, 5)} ${val.substring(5, 10)}`;
  }
  return val;
};

export const mobileNumberFormatNumber = val => {
  return val ? val.replace(/[^0-9]/g, "") : "";
};

export const OTPMaxLengthCheck = () => {
  if (event && event.target && event.target.value) {
    event.target.value = event.target.value.replace(/[^0-9]/g, "").slice(0, 6);
  }
};

export const isValidMobileNumber = val => {
  const rgx = _constant.MOBILE_REG_EX;
  return rgx.test(val);
};

export const isValidEmail = val => {
  const rgx = _constant.EMAIL_REG_EX;
  if (val) {
    return rgx.test(val);
  }
  return false;
};

export const userAgent = () => {
  let mobileOrDesktop = _constant.USER_AGENT_MOBILE;
  if (window && window.navigator) {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
      mobileOrDesktop = _constant.USER_AGENT_MOBILE;
    } else {
      mobileOrDesktop = _constant.USER_AGENT_WEB;
    }
  }
  return mobileOrDesktop;
};
export const toPascalCase=(word)=> {
    const words = word.toLowerCase().split(" ");
    const capitalizedWords = words.map((w) => w.charAt(0).toUpperCase() + w.slice(1));
    return capitalizedWords.join(" ");
}

export const numberWithCommas = (x, skipLimit = false) => {
  if (common.isNullOrUndefined(x)) {
    return "";
  }
  const numbers = x.toString().split(".");
  let output = "";
  if (numbers.length >= 1) {
    numbers[0] = numbers[0].replace(/[^0-9]/g, "");
    numbers[0] = isNaN(parseInt(numbers[0])) ? "" : parseInt(numbers[0]);
    if (numbers[0]) {
      if (!skipLimit && numbers[0] >= 100000000) {
        numbers[0] = parseInt(`${numbers[0]}`.substring(0, 8));
      }
      if (window.Number && window.Number.prototype.toLocaleString) {
        output = numbers[0].toLocaleString("en-in");
      } else {
        output = numbers[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
  }
  if (numbers.length >= 2) {
    if (numbers[1]) {
      numbers[1] = numbers[1].toString().replace(/[^0-9]/g, "");
    }
    numbers[1] = `${numbers[1]}0`.toString().substring(0, 2);
    if (/^[0]+$/.test(numbers[1])) {
      return output;
    }
    output = `${output}.${numbers[1]}`;
  }
  if (output && output < 1) {
    output = parseFloat(output).toString();
  }
  return output;
};

export const formatTotalAmount = x => {
  if (common.isNullOrUndefined(x)) {
    return "";
  }
  const numbers = x.toString().split(".");
  let output = "";
  if (numbers.length >= 1) {
    numbers[0] = numbers[0].replace(/[^0-9]/g, "");
    numbers[0] = isNaN(parseInt(numbers[0])) ? "" : parseInt(numbers[0]);
    if (numbers[0]) {
      if (window.Number && window.Number.prototype.toLocaleString) {
        output = numbers[0].toLocaleString("en-in");
      } else {
        output = numbers[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
  }
  if (numbers.length >= 2) {
    if (numbers[1]) {
      numbers[1] = numbers[1].toString().replace(/[^0-9]/g, "");
    }
    output = `${output}.${numbers[1].substring(0, 2)}`;
  }
  if (output && output < 1) {
    output = parseFloat(output).toString();
  }
  return output;
};

export const numberWithoutCommas = number => {
  if (common.isNullOrUndefined(number)) {
    return "";
  }
  return number.replace(/,/g, "");
};

/**
 * obj is the object in which you want to find the key
 * path is the key you want to find
 * default value is the one which you want to return if no value is found
 */
export const getKey = (obj, path, defaultValue) => {
  const result = String.prototype.split
    .call(path, /[,[\].]+?/)
    .filter(Boolean)
    .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
  return result === undefined || result === obj ? defaultValue : result;
};

/**
 * Get currency symbol based on APP_DATA (used by form, link, status, etc.)
 * - INR → ₹
 * - USD / other foreign currency → currency code (e.g. "USD ", "EUR ")
 */
export const getCurrencySymbol = () => {
  const payOptions = window.APP_DATA || {};
  const foreignCurrencyCode = getKey(payOptions, 'mccPaymentInfo.foreignCurrencyCode', null);
  const mccCurrency = getKey(payOptions, 'mccPaymentInfo.currency', null);
  const rootCurrency = getKey(payOptions, 'currency', null);
  const formCurrency = getKey(payOptions, 'paymentFormData.currency', null);

  const currency = foreignCurrencyCode || mccCurrency || rootCurrency || formCurrency;
  return (currency && currency !== 'INR') ? `${currency} ` : '₹';
};

export const getMonthNameDate = (inputDate, format = _constant.DMY_FORMAT, monthType = "full") => {
  const date = inputDate.split("/");
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  if (date.length === 3) {
    let day = Number(date[0]);
    let year = date[2];
    const month = monthType === "short" ? monthNames[date[1] - 1].substring(0, 3) : monthNames[date[1] - 1];
    if (format === _constant.YMD_FORMAT) {
      [year] = date;
      day = Number(date[2]);
    }
    return `${day} ${month} ${year}`;
  }
  return "";
};

export const getQueryParams = (params, url) => {
  try {
    const href = url;
    const reg = new RegExp(`[?&]${params}=([^&#]*)`, "i");
    const queryString = reg.exec(href);
    return queryString ? decodeURIComponent(queryString[1]) : null;
  } catch (e) {
    return null;
  }
};

export const convertRupeeCharToUnicode = (text) => {
  const rupeeUnicode = String.fromCodePoint(0x20b9);
  return (text || '').replace(/₹/g, rupeeUnicode);
}


// WEBPACK FOOTER //
// ./utils/utility.js